import { ModelBase, Column } from 'loca-boot-core'

export class AreaInfo extends ModelBase {
    @Column()
    public employeeDifference!: string
  }